import { useState } from 'react';
import { faPlay } from '@fortawesome/pro-regular-svg-icons';

import LayerSelector from '@App/components/LayerSelector/LayerSelector';
import LayerControl from '@App/components/MaplibreMap/LayerControl/LayerControl';
import SearchControl from '@App/components/MaplibreMap/SearchControl/SearchControl';
import CaseStudyMapCard from '@App/pages/CaseStudy/CaseStudyMapCard/CaseStudyMapCard';
import MapContainer from '@App/components/MapContainer/MapContainer';
import MapCard from '@App/components/MapCard/MapCard';
import { useTranslation } from '@utils/i18n/i18n';

import { LOCATION } from '../Context/context.constants';

import { LAYER_ORDER, getLayerConfig } from './scenarios.utils';
import ScenariosCommunitiesLayer from './ScenariosCommunitiesLayer/ScenariosCommunitiesLayer';
import ScenariosLandUseLayer from './ScenariosLandUseLayer/ScenariosLandUseLayer';
import ScenariosLegend from './ScenariosLegend/ScenariosLegend';

import './scenarios.css';

function Scenarios() {
  const { t } = useTranslation();
  const [selectedLayer, setSelectedLayer] = useState('risk');

  return (
    <CaseStudyMapCard
      className="case-study__section pagasitikos-gulf-scenarios"
      initialCenter={LOCATION.coordinates}
      initialZoom={8.5}
      label={t('Risk maps & scenarios')}
      headerIcon={faPlay}
    >
      {selectedLayer === 'coastalHazardZone'
        ? <ScenariosLandUseLayer />
        : <ScenariosCommunitiesLayer selectedLayer={selectedLayer} />}
      <MapContainer position="top-left">
        <MapCard className="pagasitikos-gulf-scenarios__layer-selector">
          <LayerSelector
            title={t('Layers')}
            groups={[
              {
                layers: LAYER_ORDER.map(key => ({
                  label: t(getLayerConfig(key).label),
                  value: key,
                })),
                selectedLayer,
                onChange: e => setSelectedLayer(e.target.value),
                collapsible: false,
              },
            ]}
          />
        </MapCard>
      </MapContainer>
      <MapContainer position="bottom-right">
        <MapCard>
          <ScenariosLegend selectedLayer={selectedLayer} />
        </MapCard>
      </MapContainer>
      <LayerControl />
      <SearchControl />
    </CaseStudyMapCard>
  );
}

export default Scenarios;
